import { ContactUs } from '@/pages/home/components/contact-us'
import { DealsSection } from '@/pages/home/components/deals-section'
import { MainSection } from '@/pages/home/components/main-section'
import { PerksSection } from '@/pages/home/components/perks-section'
import { PokerRooms } from '@/pages/home/components/poker-rooms'
import { RbWizardPros } from '@/pages/home/components/rbwizard-pros'
import { RewardsDescription } from '@/pages/home/components/rewards-description'
import { SupportSection } from '@/pages/home/components/support-section'

export const RootRoute = () => {
  return (
    <>
      <MainSection />
      <DealsSection />
      <ContactUs />
      <RewardsDescription />
      <PerksSection />
      <RbWizardPros />
      <SupportSection />
      <PokerRooms />
    </>
  )
}
